import { Center, Container, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {  useParams } from "react-router-dom";
import { useEffect } from "react";
import { CLIENT_ID_KEY } from "../utils/constants";

export default function Home() {
  const { t } = useTranslation();

  const { context: contextParam } = useParams();
  useEffect(() => {
    const previousContext = localStorage.getItem(CLIENT_ID_KEY);
    const newContext = `${window.location.host}/${contextParam}`;

    if (previousContext !== newContext) {
      localStorage.setItem(CLIENT_ID_KEY, newContext);
    }
  }, [contextParam]);

  return (
    <Container>
      <Center>
        <Text textAlign="center" fontWeight="900" color="primary" fontSize="4xl">
          {t("welcomeToOzeLoans")} 👋🏼
        </Text>
      </Center>
    </Container>
  );
}
